export default "__VITE_ASSET__ab370e7a__"